export type GetLogResponse = Buffer
